/**
 * Create instance of Parrallax.js
 *
 * @since   1.0.0
 * @package mel
 */

(function($) {
	$(document).ready(function() {

		if ( $('#banner-parallax-scene').length > 0 ) {
			var scene = $('#banner-parallax-scene').get(0);
			var parallaxInstance = new Parallax(scene);
		}

	}); // document.ready
})(jQuery);